module.exports = __webpack_public_path__ + "static/media/logo.f01de4b7.svg";